// extracted by mini-css-extract-plugin
export var box = "_1z-2";
export var checkboxControl = "_1z-0";
export var checkboxRow = "_1z-a";
export var checked = "_1z-3";
export var descriptionSpacer = "_1z-c";
export var disabled = "_1z-4";
export var icon = "_1z-8";
export var input = "_1z-1";
export var labelSpacer = "_1z-b";
export var large = "_1z-7";
export var medium = "_1z-6";
export var small = "_1z-5";
export var text = "_1z-9";